import { render, staticRenderFns } from "./ProjecaoVendasPersonalizada.vue?vue&type=template&id=2fa51911&scoped=true"
import script from "./ProjecaoVendasPersonalizada.vue?vue&type=script&lang=js"
export * from "./ProjecaoVendasPersonalizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa51911",
  null
  
)

export default component.exports